<template>
  <div class="workspace__container__view">
    <div class="workspace__container__view__header">
      <div class="workspace__container__view__header__actions"></div>
      <div class="workspace__container__view__header__filter">
        <div class="container__inputs">
          <div class="settings-input full-size">
            <input type="text" v-model="filterModel.name" :placeholder="$t('workspace.station_config.filter_for') + $t('workspace.station_config.name')" @change="orderStations()">
          </div>
        </div>
        <button :disabled="filterModel.name == ''" @click="filterModel.name = ''; orderStations()"><i class="material-icons" style="font-size: 20px">filter_alt_off</i></button>
      </div>
    </div>

    <div class="table-scroll">
      <table class="workspace__container__view__table with-padding">
        <thead>
          <tr>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'callSign' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'callSign'); orderStations()">
                <span>{{ $t("workspace.station_config.callSign") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'callSign'}">{{sortAdvanced.filter == 'callSign' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'name' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'name'); orderStations()">
                <span>{{ $t("workspace.station_config.name") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'name'}">{{sortAdvanced.filter == 'name' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'commercialBreakMaxTime' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'commercialBreakMaxTime'); orderStations()">
                <span>{{ $t("workspace.station_config.commercialBreakMaxTime") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'commercialBreakMaxTime'}">{{sortAdvanced.filter == 'commercialBreakMaxTime' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>{{ $t("workspace.station_config.logo") }}</th>
            <th>{{ $t("workspace.station_config.signature") }}</th>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'certifySignatureSubject' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'certifySignatureSubject'); orderStations()">
                <span>{{ $t("workspace.station_config.signature_label") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'certifySignatureSubject'}">{{sortAdvanced.filter == 'certifySignatureSubject' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th>
              <div class="column-filtered" @click="(sortAdvanced.filter == 'certifyLanguage' ? sortAdvanced.desc = !sortAdvanced.desc : sortAdvanced.filter = 'certifyLanguage'); orderStations()">
                <span>{{ $t("workspace.station_config.certify_lang") }}</span> 
                <i class="material-icons" :class="{'active': sortAdvanced.filter == 'certifyLanguage'}">{{sortAdvanced.filter == 'certifyLanguage' ? (sortAdvanced.desc ? 'arrow_drop_down' : 'arrow_drop_up') : 'arrow_drop_down'}}</i>
              </div>
            </th>
            <th class="actions">{{ $t("workspace.station_config.actions") }}</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="listStations(filterModel).length > 0">
            <tr v-for="item in listStationsFiltered" :key="item.code">
              <td>{{ item.callSign || '-' }}</td>
              <td v-html="highlightText(item.name, filterModel.name)"></td>
              <td>{{ item.commercialBreakMaxTime || '-' }}</td>
              <td>
                <a :href="getUrlImage(item.image)" target="_blank" v-if="item.image" class="view_logo">
                  <span class="material-icons">image</span>
                  {{ $t("workspace.station_config.view_logo") }}
                </a>
                <span v-else>-</span>
              </td>
              <td>
                <a :href="getUrlImage(item.certifySignature)" target="_blank" v-if="item.certifySignature" class="view_logo"> 
                  <span class="material-icons">image</span>
                  {{ $t("workspace.station_config.view_signature") }}
                </a>
                <span v-else>-</span>
              </td>
              <td>{{ item.certifySignatureSubject || '-' }}</td>
              <td>{{ item.certifyLanguage == 'en-US' ? $t("workspace.station_config.english") : $t("workspace.station_config.spanish") || '-' }}</td>
              <td class="actions">
                <i class="material-icons" @click="createOrEdit(item)">edit</i>
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="3" v-html="$t('workspace.none_results_with_filters')"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { useStore } from 'vuex'
import { computed, onMounted } from '@vue/runtime-core';
import eventBus from '@/plugins/eventBus';
import highlightText from '@/plugins/Mixin/highlightText.js';

export default {
  mixins: [highlightText],
  setup() {
    const store = useStore();
    const listStations = computed(() => filterModel => store.getters.station_stations(filterModel));
    const listStationsFiltered = ref([]);
    const filterModel = ref({
      name: ''
    });
    const sortAdvanced = ref({
      filter: 'callSign',
      desc: true
    })

    onMounted(async () => {
      store.dispatch('loading_setActive', true);
      const localStorageSort = localStorage.getItem('station_sort');
      if (localStorageSort) {
        sortAdvanced.value = JSON.parse(localStorageSort);
      }
      
      await store.dispatch('station_getAll');
      orderStations();
      store.dispatch('loading_setActive', false);

      eventBus.$on('reloadStations', async () => {
        await store.dispatch('station_getAll');
        orderStations();
      });
    });

    async function createOrEdit(item) {
      await store.dispatch('modal_setActive', {active: 'STATION-CONFIG_STATION_CREATE-EDIT', props: item});
    }

    function getUrlImage(path) {
      return `${process.env.VUE_APP_CDN_URL_USER}${path}`
    }

    const orderBy = function (property, order) {
      const _list = [...listStations.value(filterModel.value)];
      return _list.sort((a, b) => {
        if (property == 'commercialBreakMaxTime') {
          return order ? Number(a[property]) - Number(b[property]) : Number(b[property]) - Number(a[property]);
        } else {
          console.log(property)
          console.log(a[property] ?? '', b[property] ?? '');
          return order ? (a[property] ?? '').localeCompare(b[property] ?? '') : (b[property] ?? '').localeCompare(a[property] ?? '');
        }
      });
    }

    function orderStations() {
      listStationsFiltered.value = orderBy(sortAdvanced.value.filter, sortAdvanced.value.desc);
      localStorage.setItem('station_sort', JSON.stringify({
        filter: sortAdvanced.value.filter,
        desc: sortAdvanced.value.desc
      }));
    }

    return {
      sortAdvanced,
      listStations,
      listStationsFiltered,
      filterModel,
      createOrEdit,
      getUrlImage,
      orderStations
    }
  }
}
</script>
<style lang="scss">
.view_logo {
  color: #fff;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  gap: 4px;
  align-items: center;
}

th:has(.column-filtered:hover) {
  background: #6060607e;
}
.column-filtered {
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;

  &:has(th:hover) th { 
    background: #6060607e;
  }

  i {
    display: none;
    margin-top: -2px;

    &.active {
      display: block;
    }
  }
}
</style>